<template>
	<div id='dom' class="page">
		<Tip :tip="tip" />
		<div class="from_div">
			<el-form ref="form" :model="form" label-position="left" label-width="110px">
				<el-form-item v-if="form.supplier_id != ''" label="编号：">
					<span>{{form.supplier_id}}</span>
				</el-form-item>
				<el-form-item label="供应商简称：" prop="supplier_name">
					<el-input class="input" v-model="form.supplier_name" clearable placeholder="请输入内容" />
				</el-form-item>
				<el-form-item label="供应企业名称：" prop="supplier_company">
					<el-input class="input" v-model="form.supplier_company" clearable placeholder="请输入内容" />
				</el-form-item>
				<el-form-item label="登录账号：" prop="supplier_account">
					<el-input class="input" v-model="form.supplier_account" clearable placeholder="请输入内容(手机号)" />
				</el-form-item>
				<el-form-item label="登录密码：" prop="supplier_password">
					<el-input class="input" v-model="form.supplier_password" clearable placeholder="默认密码:abc123456"/>
				</el-form-item>
				<el-form-item label="企业LOGO：" prop="supplier_logo" style="margin-bottom: 0;">
					<multiUpload :type='0' :limitImg='1' :noneBtnImg='logoList.length > 0' :fileList="logoList" @saveImg="saveImg" @delImg="delImg"/>
				</el-form-item>
				<el-form-item label="执照证件：" prop="supplier_licenses" style="margin-bottom: 0;">
					<div class="row">
						<multiUpload :type='1' :limitImg='1' :noneBtnImg='licenses.length > 0' :fileList="licenses" @saveImg="saveImg" @delImg="delImg"/>
						<multiUpload :type='2' :limitImg='1' :noneBtnImg='licenses1.length > 0' :fileList="licenses1" @saveImg="saveImg" @delImg="delImg"/>
					</div>
				</el-form-item>
				<div class="row">
					<el-form-item label="企业负责人：" prop="supplier_header">
						<el-input class="input_s" v-model="form.supplier_header" clearable placeholder="请输入内容" />
					</el-form-item>
					<el-form-item label="电话：" prop="supplier_phone" label-width="60px">
						<el-input class="input_s" v-model="form.supplier_phone" clearable placeholder="请输入内容" />
					</el-form-item>
				</div>
				<el-form-item label="收款信息：" prop="supplier_collection" style="margin-bottom:0">
					<div class="add_div" v-for="(item,index) in form.supplier_collection">
						<div class="item_div">
							<el-input class="input" v-model="item.bank" clearable placeholder="开户银行" />
							<el-input class="input" v-model="item.account" clearable placeholder="银行账户" />
							<el-input class="input" v-model="item.name" clearable placeholder="账号户名" />
							<el-button type="primary" plain @click="addItem(index+1)">添加</el-button>
							<el-button v-if="index > 0" type="danger" plain @click="deleteItem(index)">删除</el-button>
						</div>
					</div>
				</el-form-item>
				<el-form-item label="合作到期：" prop="supplier_expire">
					<el-date-picker v-model="form.supplier_expire" type="datetime" placeholder="选择日期时间"
						value-format="yyyy-MM-dd HH:mm:ss" />
				</el-form-item>
				<el-form-item label="主营类目：" prop="supplier_cates">
					<el-input class="input_" v-model="form.supplier_cates" clearable placeholder="请输入内容" />
				</el-form-item>
				<el-form-item label="其他备注：" prop="supplier_remark">
					<el-input class="input_" v-model="form.supplier_remark" clearable placeholder="请输入内容" />
				</el-form-item>
			</el-form>
		</div>
		<div class="foot_div">
			<el-button @click="close">返回</el-button>
			<el-button type="primary" @click="submitForm('form')">确定</el-button>
		</div>
	</div>
</template>

<script>
	import Tip from "../../../components/Tip/Tip.vue"
	import multiUpload from "../../../components/multiUpload/multiUpload.vue"
	import {
		mapGetters
	} from 'vuex';
	import {
		supplierAdd,
		supplierEdit,
		supplierDetail
	} from "../../../request/apis.js"
	export default {
		components: {
			Tip,
			multiUpload
		},
		props: {
			type: {
				type: Number
			}
		},
		data() {
			return {
				tip: '供应商信息维护。',
				logoList:[],//企业logo图片
				licenses:[],
				licenses1:[],
				form: {
					supplier_id: '', //供应商id
					supplier_name: '', //供应商简称
					supplier_company: '', //供应企业名称
					supplier_account: '', //登录账号
					supplier_password:'abc123456',//登录密码
					supplier_logo: '', //企业LOGO
					supplier_licenses: [], //执照证件
					supplier_header: '', //企业负责人
					supplier_phone: '', //电话
					supplier_collection: [ //收款信息
						{
							bank: '', //开户行
							account: '', //银行账户
							name: '' //账号户名
						}
					],
					supplier_expire: '', //合作到期时间
					supplier_cates: '', //主营类目
					supplier_remark: '' //备注
				}
			}
		},
		computed: {
			...mapGetters(['loginInfo']),
		},
		mounted() {
			this.$watermark.set(this.loginInfo.nick_name + '-' + this.loginInfo.phone.substr(this.loginInfo.phone.length-4), dom);
			if (this.type != -1) {
				//详情编辑
				this.form.supplier_id = this.type;
				this.getSupplierDetail();
			}
		},
		methods: {
			
			//获取供应商详情
			getSupplierDetail(){
				supplierDetail({supplier_id:this.form.supplier_id}).then(res=>{
					if(res.code == 0){
						if(res.data.supplier_logo != ''){
							this.logoList.push({url:res.data.supplier_logo})
						}
						if(res.data.supplier_licenses[0] != ''){
							this.licenses.push({url:res.data.supplier_licenses[0]})
						}
						if(res.data.supplier_licenses[1] != ''){
							this.licenses1.push({url:res.data.supplier_licenses[1]})
						}
						for (var key in res.data) {
							if (this.form.hasOwnProperty(key)) {
								this.form[key] = res.data[key];
							}
						}
					}
				}).catch(err=>{})
			},
			
			//添加收款信息条目
			addItem(index){
				var obj = {
					bank: '', //开户行
					account: '', //银行账户
					name: '' //账号户名
				}
				this.form.supplier_collection.splice(index,0,obj)
			},
			
			//移除收款信息条目
			deleteItem(index){
				this.form.supplier_collection.splice(index,1)
			},
			
			//图片存储
			saveImg(arr){
				if(arr[1] == 0){
					//企业logo
					this.form.supplier_logo = arr[0];
				}else{
					//执照证件
					this.form.supplier_licenses.splice(arr[1] - 1, 0, arr[0]);
				}
			},
			
			//图片删除
			delImg(arr){
				switch (arr[1]){
					case 0:
					//企业logo
					this.form.supplier_logo = '';
					this.logoList = []
						break;
					case 1:
					//执照证件
					this.form.supplier_licenses.splice(0, 1);
					this.licenses = []
						break;
					case 2:
					//执照证件
					this.form.supplier_licenses.splice(1, 1);
					this.licenses1 = []
						break;
				}
				
			},
			
			//提交表单
			submitForm(form) {
				this.$refs[form].validate((valid) => {
					if (valid) {
						if (this.type != -1) {
							//编辑
							supplierEdit({
								...this.form
							}).then(res => {
								if (res.code == 0) {
									this.logoList = [],//企业logo图片
									this.licenses = [],
									this.licenses1 = [],
									this.$emit('close', 0)
									this.$message.success(res.msg);
								}else{
									this.$message.error(res.msg);
								}
							}).catch(err => {})
						} else {
							//新增
							supplierAdd({
								...this.form
							}).then(res => {
								if (res.code == 0) {
									this.logoList = [],//企业logo图片
									this.licenses = [],
									this.licenses1 = [],
									this.$emit('close', 0)
									this.$message.success(res.msg);
								}else{
									this.$message.error(res.msg);
								}
							}).catch(err => {})
						}
					} else {
						return false;
					}
				});
			},

			close() {
				this.$emit('close', 1)
			}
		}
	}
</script>

<style scoped>
	.page {
		width: calc(100% - 40px);
		background: #fff;
		position: relative;
		padding: 20px 20px 0 20px;
	}

	.row {
		display: flex;
		flex-direction: row;
	}

	.from_div {
		margin-top: 20px;
		width: 100%;
		overflow: scroll;
		height: 644px;
		min-height: 100%;
		padding-bottom: 66px;
	}

	.input {
		width: 200px;
		margin-right: 25px;
	}

	.input_s {
		width: 130px;
		margin-right: 100px;
	}

	.input_ {
		width: 435px;
	}

	.add_div {
		display: flex;
		flex-direction: column;
	}

	.item_div {
		display: flex;
		flex-direction: row;
		margin-bottom: 22px;
	}

	.upload_div {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		width: 90px;
		height: 90px;
		background-color: #fbfdff;
		border: 1px dashed #c0ccda;
		border-radius: 6px;
	}

	.upload_div_ {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		width: 160px;
		height: 90px;
		background-color: #fbfdff;
		border: 1px dashed #c0ccda;
		border-radius: 6px;
		margin-right: 25px;
	}

	.foot_div {
		position: absolute;
		bottom: 0;
		left: 0;
		width: calc(100% - 120px);
		padding: 0 60px;
		line-height: 66px;
		height: 66px;
		background: #fff;
		box-shadow: 0px -4px 10px -5px rgba(0, 0, 0, 0.3);
		border-radius: 0 0 10px 10px;
	}

	.span {
		font-size: 14px;
		color: #606266;
		margin-left: 100px;
	}

	.span_ {
		font-size: 12px;
		font-weight: normal;
		line-height: normal;
		color: #767676;
		margin-top: 5px;
	}

	.el-icon-plus {
		font-size: 20px;
		font-weight: bolder;
		color: #606266;
	}
</style>